import { Component, OnInit } from '@angular/core';
import { BookingsService } from '../services/bookings.service'
import { Booking } from '../models/Booking.model'
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  toDayCheckIn: number = 0;
  unconfirmedBooking: number = 0;
  confirmedBooking: number = 0;
  cancelledBooking: number = 0;

  bookings: Booking[];
  bookingsSubscription: Subscription;


  constructor(private bookingService: BookingsService) { }

  ngOnInit() {
    this.bookingService.getBookingsByStatus()
      .then((bookings: Booking[]) => {
        bookings.forEach((booking) => {
          if(booking.status == "PENDING") {
            this.unconfirmedBooking++;
          }
          else if (booking.status == "CONFIRMED") {
            this.confirmedBooking++;
          }
          else if (booking.status == "CANCELLED") {
            this.cancelledBooking++;
          }
        });
      });

    this.bookingService.getBookingsByRoomNumber("342").then(
      (bookings: Booking[]) => {
        this.bookings = bookings;
      }
    )

    /*

    this.bookingService.getBookingsByClient("Messi").then(
      (bookings: Booking[]) => {
        bookings.forEach((booking) => {
          console.log("CHAMBRE: " + booking.room_id);
          console.log("CLIENT: " + booking.client_id);
          console.log("ARRIVEE: " + booking.check_in);
          console.log("DEPART: " + booking.check_out);
          console.log("STATUS: " + booking.status);
          console.log("PAYMENT: " + booking.payment_status);
        });
      }
    );
    */
  /*
    this.bookingService.getBookingsByCheckIn("2019-05-12").then(
      (bookings: Booking[]) => {
        console.log(Date.now().toString());
        bookings.forEach((booking) => {
          console.log("CHAMBRE: " + booking.room_id);
          console.log("CLIENT: " + booking.client_id);
          console.log("ARRIVEE: " + booking.check_in);
          console.log("DEPART: " + booking.check_out);
          console.log("STATUS: " + booking.status);
          console.log("PAYMENT: " + booking.payment_status);
        });
      }
    );*/
  }

}
